import {
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useReducer,
} from 'react';
import {
  MessageContextAction,
  MessageContextActionType,
  MessageContextState,
  MessageContextType,
} from './messageContext.types';

const initialState: MessageContextState = {
  jobId: '',
};

const messageReducer = (
  state: MessageContextState,
  action: MessageContextAction,
) => {
  switch (action.type) {
    case MessageContextActionType.SET_JOB_ID:
      return {
        ...state,
        jobId: action.jobId,
      };
    case MessageContextActionType.CLEAR_JOB_ID:
      return {
        ...state,
        jobId: '',
      };
    default: {
      throw new Error(`Unhandled action type`);
    }
  }
};

const MessageContext = createContext<MessageContextType | undefined>(undefined);

export const MessageContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [state, dispatch] = useReducer(messageReducer, initialState);

  const value = useMemo(() => ({ state, dispatch }), [state, dispatch]);

  return (
    <MessageContext.Provider value={value}>{children}</MessageContext.Provider>
  );
};

export const useMessageContext = (): MessageContextType => {
  const context = useContext(MessageContext);

  if (context === undefined) {
    throw new Error(
      'useMessageContext must be used within a MessageContextProvider',
    );
  }

  return context;
};
